import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
/* import Meta from 'vue-meta' */

Vue.use(VueRouter)
/* Vue.use(Meta) */

const routes = [
  {
    path: '/',
    name: 'Hjem',
    component: Home
  },
  {
    path: '/konferanse',
    name: 'Konferanse',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "konferanse" */ '../views/Konferanse.vue')
  },
  {
    path: '/dagmoter',
    name: 'Dagmoter',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "dagmoter" */ '../views/Dagmoter.vue')
  },  
  {
    path: '/pizzeria-del-generale',
    name: 'Pizzeria',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "pizzeria-del-generale" */ '../views/Pizzeria.vue')
  },    
  {
    path: '/selskap',
    name: 'Selskap',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "selskap" */ '../views/Selskap.vue')
  },    
  {
    path: '/meny',
    name: 'Meny',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "meny" */ '../views/Meny.vue')
  },      
  {
    path: '/catering',
    name: 'Catering',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "catering" */ '../views/Catering.vue')
  },      
  {
    path: '/blogg',
    name: 'Hotellbloggen',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "selskap" */ '../views/Blogg.vue')
  },      
  {
    path: '/om-oss/bedriften',
    name: 'Om',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "om-oss/bedriften" */ '../views/Om.vue')
  },        
  {
    path: '/om-oss/jobb',
    name: 'Jobb',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "om-oss/jobb" */ '../views/Jobb.vue')
  },        
  {
    path: '/om-oss/yrke',
    name: 'Yrke',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "om-oss/yrke" */ '../views/Yrke.vue')
  },          
  {
    path: '/om-oss/kontakt',
    name: 'Kontakt',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "om-oss/kontakt" */ '../views/Kontakt.vue')
  },            
  {
    path: '/om-oss/veien-hit',
    name: 'Veien',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "om-oss/veien-hit" */ '../views/Veien.vue')
  },            
  {
    path: '/om-oss/personvern',
    name: 'Personvern',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "om-oss/personvern" */ '../views/Personvern.vue')
  },          
  {
    path: '/opplevelser/spill',
    name: 'PersoSpillnvern',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "opplevelser/spill" */ '../views/Spill.vue')
  },            
  {
    path: '/opplevelser/aktiviteter',
    name: 'Aktiviteter',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "opplevelser/aktiviteter" */ '../views/Aktiviteter.vue')
  },         
  {
    path: '/smitte',
    name: 'Smitte',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "smitte" */ '../views/Smitte.vue')
  },   
  {
    path: '/smittevern',
    name: 'Smittevern',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "smittevern" */ '../views/Smittevern.vue')
  },   
  {
    path: '/konsept',
    name: 'Konsept',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // Bruk denne metoden på alle routes - ellers lastes hele siden når forsiden lastes. 
    component: () => import(/* webpackChunkName: "konsept" */ '../views/Konsept.vue')
  },                    
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
